import React from "react";
import classes from "./SubscriptionPage.module.css";
import { motion } from "framer-motion";

const SubscriptionPage = () => {
  return (
    <main className={classes.main}>
      <motion.div
        className={classes.container}
        initial={{
          backgroundImage:
            "radial-gradient(820% 320% at 50% 25%, #000,#e20808)",
        }}
        animate={{
          backgroundImage: [
            "radial-gradient(820% 320% at 50% 25%, #000,#e20808)",
            "radial-gradient(820% 320% at 50% 25%, #000, #0a58b7)",
            "radial-gradient(820% 320% at 50% 25%, #000, #f5b342)",
            "radial-gradient(820% 320% at 50% 25%, #000, #8e44ad)",
          ],
        }}
        transition={{
          duration: 6,
          ease: "easeInOut",
          repeat: Infinity,
          repeatType: "mirror",
        }}
      >
        {/* glow particles */}
        <div className={classes.glowLayer} />

        <section className={classes.shell}>
          {/* TOP BAR */}
          <header className={classes.topBar}>
            <div className={classes.brand}>
              <span className={classes.brandMark} />
              <div className={classes.brandText}>
                <div className={classes.brandTitle}>
                  UV <span>GAMING</span>
                </div>
                <div className={classes.brandSub}>Powered by Vodafone</div>
              </div>
            </div>

            <div className={classes.topActions}>
              <button className={classes.btnGhost}>Entrar</button>
              <button className={classes.btnPrimary}>Subscrever</button>
            </div>
          </header>

          {/* HERO */}
          <section className={classes.hero}>
            <div className={classes.heroLeft}>
              <h1 className={classes.heroTitle}>
                Jogos Ilimitados <br />
                <span>no Teu Telemóvel</span>
              </h1>

              <div className={classes.pricePill}>
                A partir de <b>3MT</b> / Dia
              </div>

              <div className={classes.metaRow}>
                <div className={classes.metaChip}>📱 HTML5 + Android</div>
                <div className={classes.metaChip}>💳 Paga com Saldo ou M-Pesa</div>
              </div>
            </div>

            <div className={classes.heroRight}>
              <div className={classes.heroArt}>
                {/* Placeholder: put hero image here */}
                <div className={classes.heroGlowRing} />
                <div className={classes.heroImageMock}>
                  <span>Hero Image</span>
                </div>
              </div>
            </div>
          </section>

          {/* PLANS + HOW IT WORKS */}
          <section className={classes.middleGrid}>
            <div className={classes.plans}>
              <div className={classes.sectionTitle}>Escolhe o Teu Plano</div>

              <div className={classes.planGrid}>
                <div className={classes.planCard}>
                  <div className={classes.planHead}>
                    <div className={classes.planName}>Diário</div>
                    <div className={classes.planPrice}>
                      <span>3</span>MT
                    </div>
                  </div>

                  <ul className={classes.planList}>
                    <li>🎮 Acesso 24H</li>
                  </ul>

                  <button className={classes.planBtn}>Subscrever</button>
                </div>

                <div className={`${classes.planCard} ${classes.planPopular}`}>
                  <div className={classes.badge}>Mais Popular</div>

                  <div className={classes.planHead}>
                    <div className={classes.planName}>Semanal</div>
                    <div className={classes.planPrice}>
                      <span>20</span>MT
                    </div>
                  </div>

                  <ul className={classes.planList}>
                    <li>🗓️ 7 Dias de Jogos</li>
                  </ul>

                  <button className={classes.planBtn}>Subscrever</button>
                </div>

                <div className={classes.planCard}>
                  <div className={classes.badgeAlt}>Melhor Valor</div>

                  <div className={classes.planHead}>
                    <div className={classes.planName}>Mensal</div>
                    <div className={classes.planPrice}>
                      <span>50</span>MT
                    </div>
                  </div>

                  <ul className={classes.planList}>
                    <li>📅 30 Dias de Jogos</li>
                  </ul>

                  <button className={classes.planBtn}>Subscrever</button>
                </div>
              </div>
            </div>

            <aside className={classes.how}>
              <div className={classes.howTitle}>Como Funciona?</div>

              <div className={classes.steps}>
                <div className={classes.step}>
                  <div className={classes.stepNum}>1</div>
                  <div className={classes.stepText}>Escolhe o Plano</div>
                </div>
                <div className={classes.step}>
                  <div className={classes.stepNum}>2</div>
                  <div className={classes.stepText}>Paga (M-Pesa/Saldo)</div>
                </div>
                <div className={classes.step}>
                  <div className={classes.stepNum}>3</div>
                  <div className={classes.stepText}>Começa a Jogar!</div>
                </div>
              </div>

              <button className={classes.activateBtn}>
                Ativar Agora <span className={classes.arrow}>➜</span>
              </button>
            </aside>
          </section>

          {/* FEATURED */}
          <section className={classes.featured}>
            <div className={classes.featuredHead}>
              <div className={classes.sectionTitle}>Jogos em Destaque</div>
              <button className={classes.linkBtn}>Ver Todos</button>
            </div>

            <div className={classes.gameRow}>
              {[
                "Car Racing",
                "Battle Arena",
                "Futebol Pro",
                "Aventura",
                "Puzzle",
              ].map((name, idx) => (
                <button key={idx} className={classes.gameCard}>
                  <div className={classes.gameThumb}>
                    <span>Img</span>
                  </div>
                  <div className={classes.gameName}>{name}</div>
                </button>
              ))}
            </div>
          </section>

          {/* PAYMENT + APP */}
          <section className={classes.bottomGrid}>
            <div className={classes.paymentCard}>
              <div className={classes.cardTitle}>Pagamento Fácil</div>
              <div className={classes.logoGrid}>
                <div className={classes.logo}>Vodafone</div>
                <div className={classes.logo}>M-Pesa</div>
                <div className={classes.logo}>VISA</div>
                <div className={classes.logo}>Mastercard</div>
              </div>

              <div className={classes.cardMeta}>🔒 Seguro e Instantâneo</div>
            </div>

            <div className={classes.appCard}>
              <div className={classes.appLeft}>
                <div className={classes.cardTitle}>App Android</div>
                <button className={classes.downloadBtn}>Download Now</button>
                <div className={classes.rating}>4.8 ⭐⭐⭐⭐⭐</div>
              </div>

              <div className={classes.phoneMock}>
                <span>Phone</span>
              </div>
            </div>
          </section>

          {/* FOOT QUICK ACTIONS */}
          <footer className={classes.footerActions}>
            <div className={classes.footChip}>💬 Suporte 24/7</div>
            <div className={classes.footChip}>⛔ Cancela Quando Quiseres</div>
          </footer>
        </section>
      </motion.div>
    </main>
  );
};

export default SubscriptionPage;